import { EventMapInterface } from '@/domains/common/typescript/EventMapInterface';

type Callback<K extends keyof EventMapInterface> = (arg: EventMapInterface[K]) => void;

type CallbackEntry<K extends keyof EventMapInterface> = {
    symbol: symbol;
    callback: Callback<K>;
};

export class EventBus {
    private callbacks = new Map<keyof EventMapInterface, CallbackEntry<keyof EventMapInterface>[]>();

    emit<K extends keyof EventMapInterface>(
        eventName: K,
        ...args: EventMapInterface[K] extends void ? [] : [EventMapInterface[K]]
    ): void {
        const list = this.callbacks.get(eventName) as CallbackEntry<K>[] | undefined;
        list?.forEach(({ callback }) => {
            // @ts-expect-error ts(2556) : TS ne peut pas inférer proprement ici, mais c'est safe via le type au-dessus
            callback(...args);
        });
    }

    on<K extends keyof EventMapInterface>(eventName: K, callback: Callback<K>): symbol {
        const symbol = Symbol(eventName);
        const entry: CallbackEntry<K> = { symbol, callback };
        const list = (this.callbacks.get(eventName) as CallbackEntry<K>[] | undefined) ?? [];
        this.callbacks.set(eventName, [...list, entry] as CallbackEntry<keyof EventMapInterface>[]);
        return symbol;
    }

    off(symbol: symbol): void {
        for (const [eventName, list] of this.callbacks.entries()) {
            const filtered = list.filter((entry) => entry.symbol !== symbol);
            this.callbacks.set(eventName, filtered);
        }
    }
}

const eventBus = new EventBus();

export default eventBus;
